export default "__VITE_ASSET__tlwix4af__"